const STORAGE_KEY = 'unada_eod_reports';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(reports) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reports));
}

function sortReports(list) {
  return [...list].sort(
    (a, b) =>
      (b.date || '').localeCompare(a.date || '') ||
      (a.salesperson || '').localeCompare(b.salesperson || '')
  );
}

export function listLocalEodReports(params = {}) {
  let list = readAll();
  if (params.date) list = list.filter(r => r.date === params.date);
  if (params.salesperson) list = list.filter(r => r.salesperson === params.salesperson);
  return sortReports(list);
}

export function submitLocalEodReport(data) {
  const { date, salesperson, note, snapshot } = data;
  if (!date || !salesperson) throw new Error('date and salesperson required');

  const list = readAll();
  const idx = list.findIndex(r => r.date === date && r.salesperson === salesperson);
  const now = new Date().toISOString();
  const report = {
    _id: idx >= 0 ? list[idx]._id : `local_${date}_${salesperson}`.replace(/[^a-zA-Z0-9_-]/g, '_'),
    date,
    salesperson,
    note: note || '',
    snapshot: snapshot || {},
    createdAt: idx >= 0 ? list[idx].createdAt : now,
    updatedAt: now,
    _localOnly: true,
  };

  if (idx >= 0) list[idx] = report;
  else list.push(report);
  writeAll(list);
  return report;
}

export function deleteLocalEodReport(id) {
  writeAll(readAll().filter(r => String(r._id) !== String(id)));
  return { success: true };
}
